import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b1e63b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fd-invest" }
const _hoisted_2 = {
  key: 0,
  class: "el-carousel el-carousel--horizontal fd-invest-carousel"
}
const _hoisted_3 = { class: "el-carousel__container" }
const _hoisted_4 = {
  class: "el-carousel__item is-active is-animating",
  style: {"background-color":"#FFFFFF"}
}
const _hoisted_5 = { class: "fd-center fd-invest-ct" }
const _hoisted_6 = { class: "fd-invest-data" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("近期招商数据")
const _hoisted_8 = { class: "fd-invest-data-rt" }
const _hoisted_9 = { class: "fd-invest-data-nums" }
const _hoisted_10 = { class: "fd-invest-data-nums-n" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-invest-data-des" }, "物业发布项目数", -1))
const _hoisted_13 = { class: "fd-invest-data-rt" }
const _hoisted_14 = { class: "fd-invest-data-nums" }
const _hoisted_15 = { class: "fd-invest-data-nums-n" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-invest-data-des" }, "商家关注度", -1))
const _hoisted_18 = { class: "fd-invest-data-rt" }
const _hoisted_19 = { class: "fd-invest-data-nums" }
const _hoisted_20 = { class: "fd-invest-data-nums-n" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("个 ")
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-invest-data-des" }, "商家报名数", -1))
const _hoisted_23 = { class: "fd-invest-box" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("最近招商项目")
const _hoisted_25 = { class: "fd-invest-box-tabs" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "fd-invest-box-item-img" }
const _hoisted_28 = { class: "fd-invest-box-item-img-label" }
const _hoisted_29 = { class: "fd-invest-box-item-info" }
const _hoisted_30 = { class: "fd-invest-box-item-info-tp-lt" }
const _hoisted_31 = { class: "fd-invest-box-item-info-tp-lt-name" }
const _hoisted_32 = { class: "fd-invest-box-item-info-tp-label" }
const _hoisted_33 = { class: "fd-invest-box-item-info-bt-name" }
const _hoisted_34 = { style: {"position":"relative","top":"-8px"} }
const _hoisted_35 = { class: "fd-invest-strategy" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("高效招商 轻松报名 —— 社区拎包入住全攻略")
const _hoisted_37 = { class: "fd-invest-meeting" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("业主见面会 —— 第三方活动策划公司招募")
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "fd-invest-box-item-img" }
const _hoisted_41 = { class: "fd-invest-box-item-img-label" }
const _hoisted_42 = { class: "fd-invest-box-item-info" }
const _hoisted_43 = { class: "fd-invest-box-item-info-tp-lt" }
const _hoisted_44 = { class: "fd-invest-box-item-info-tp-lt-name" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fd-invest-box-item-info-tp-label" }, null, -1))
const _hoisted_46 = { class: "fd-invest-box-item-info-bt-name" }
const _hoisted_47 = { style: {"position":"relative","top":"-8px"} }

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive } from "vue";
import tool from "@/utils/tool";
import router from "@/router/index";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import Bottom from '../components/bottom.vue'

interface ActivityVo {
  id: string;
  name: string;
  roomNumberName: string;
  deliveryDateString: string;
  decorateTypeName: string;
  thumbnailUrl: string;
  projectName: string;
  companyName: string;
  distanceDay: number;
}
interface tabNames {
  name: string;
  count: string;
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activeName = ref('碧桂园')

const ustore = useStore();
const investActivitys: ActivityVo[] = [];
const ownerActivitys: ActivityVo[] = [];
const investDeveloperNames: tabNames[] = [];
const bindData = reactive({
  investDeveloperNames: investDeveloperNames,
  investActivitys: investActivitys,
  ownerActivitys: ownerActivitys,
  calssType: ["", "", "", "status3", "status4", "status5", "status6"],
  type: ["", "", "", "即将开始", "报名中", "进行中", "已结束"],
  isShowDefaultImage: true,
  defaultImage: '',
  images: [],
  sumCounts: {},
  pageParams: {
    curPage: 1,
    pageSize: 9,
    filtrate: {
      status: "",
      keyword: "",
      type: "1",
      developerName: "",
    },
  },
  pageParams1: {
    curPage: 1,
    pageSize: 6,
    filtrate: {
      status: "",
      keyword: "",
      type: "8"
    },
  },
});

const activityEvent = (developerName: string) => {
  bindData.pageParams.filtrate.developerName = developerName;
  store
    .dispatch("frontInvestModule/listActivityListByInvest", bindData.pageParams)
    .then(
      (data) => {
        bindData.investActivitys = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const ownerAtivityEvent = () => {
  store
    .dispatch("frontInvestModule/pageActivityList", bindData.pageParams1)
    .then(
      (data) => {
        bindData.ownerActivitys = data.result;
      },
      (error) => {
        console.log(error.msg);
      }
    );
};

const developerNameEvent = () => {
  store.dispatch("frontInvestModule/listDeveloperName", { type: 1 }).then(
    (data) => {
      bindData.investDeveloperNames = data.result;
      if (data.result) {
        var result = data.result[0];
        if (result) {
          activityEvent(result.name);
        }
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
};
const sumInvestCountEvent = () => {
  store.dispatch("frontInvestModule/sumInvestCount", {}).then(
    (data) => {
      console.log(data.result);
      bindData.sumCounts = data.result;
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const advertisingImageEvent = () => {
  store.dispatch("frontIndexModule/listAdvertisingImage", { type: 2 }).then(
    (data) => {
      console.log(data.result);
      bindData.images = data.result;
      if (data.result.length > 0) {
        bindData.defaultImage = data.result[0];
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
};

const handleClick = (tab: any, event: Event) => {
  const name = bindData.investDeveloperNames[tab.index].name;
  activityEvent(name);
};

const handleToDetail = (item: any) => {
  router.push('/frontDesk/fdInvestList/fdInvestDetail/' + item.id)
}

const handleToMore = () => {
  router.push('/frontDesk/fdInvestList')
}

developerNameEvent();
advertisingImageEvent();
sumInvestCountEvent();
ownerAtivityEvent();
setTimeout(() => { bindData.isShowDefaultImage = false }, 3000);

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(bindData).isShowDefaultImage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_image, {
                class: "fd-invest-carousel-banner",
                src: _unref(bindData).defaultImage
              }, null, 8, ["src"])
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(_component_el_carousel, {
          key: 1,
          class: "fd-invest-carousel"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).images, (item, index) => {
              return (_openBlock(), _createBlock(_component_el_carousel_item, {
                key: index,
                style: {"background-color":"#FFFFFF"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_image, {
                    class: "fd-invest-carousel-banner",
                    src: item
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_container, { class: "fd-invest-divider" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, { class: "fd-invest-data-list" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_container, { class: "fd-invest-data-item" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  class: "fd-invest-data-logo",
                  src: require('@/assets/fd/invest/logo1.png')
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(bindData).sumCounts.projectNumber), 1),
                    _hoisted_11
                  ]),
                  _hoisted_12
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, { class: "fd-invest-data-item" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  class: "fd-invest-data-logo",
                  src: require('@/assets/fd/invest/logo2.png')
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(bindData).sumCounts.attentionNumber), 1),
                    _hoisted_16
                  ]),
                  _hoisted_17
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_container, { class: "fd-invest-data-item" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_image, {
                  class: "fd-invest-data-logo",
                  src: require('@/assets/fd/invest/logo3.png')
                }, null, 8, ["src"]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(bindData).sumCounts.applyNumber), 1),
                    _hoisted_21
                  ]),
                  _hoisted_22
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_el_container, { class: "fd-invest-divider" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_tabs, {
            modelValue: activeName.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
            onTabClick: handleClick
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).investDeveloperNames, (item) => {
                return (_openBlock(), _createBlock(_component_el_tab_pane, {
                  name: item.name,
                  label: item.name,
                  key: item.name
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_container, { class: "fd-invest-box-line" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).investActivitys, (item) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "fd-invest-box-item",
                            key: item.id,
                            onClick: () => handleToDetail(item)
                          }, [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_el_image, {
                                class: "",
                                src: item.thumbnailUrl
                              }, null, 8, ["src"]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["fd-invest-box-item-img-status", _unref(bindData).calssType[item.status]])
                              }, null, 2),
                              _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(bindData).type[item.status]), 1)
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_el_container, { class: "fd-invest-box-item-info-tp" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, _toDisplayString(item.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_row, {
                                gutter: 20,
                                class: "fd-index-box-item-info-ct list-row"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    span: 14,
                                    class: "col-left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.deliveryDateString) + "收楼 | " + _toDisplayString(item.decorateTypeName), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_el_col, {
                                    span: 10,
                                    class: "col-right",
                                    style: {"color":"red"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_32, _toDisplayString(item.phaseName), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_row, {
                                gutter: 20,
                                class: "fd-index-box-item-info-bt list-row"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_col, {
                                    span: 14,
                                    class: "col-left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_33, [
                                        _createVNode(_component_el_image, {
                                          class: "bbs-list-item-logo-icon",
                                          mode: "widthfix",
                                          src: item.companyLogo,
                                          style: {"width":"35px","height":"35px","margin-right":"3px"}
                                        }, null, 8, ["src"]),
                                        _createElementVNode("span", _hoisted_34, _toDisplayString(item.companyName), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (item.roomNumber > 0)
                                    ? (_openBlock(), _createBlock(_component_el_col, {
                                        key: 0,
                                        span: 10,
                                        class: "col-right",
                                        style: {"color":"red"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.roomNumber) + "户 ", 1)
                                        ]),
                                        _: 2
                                      }, 1024))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ], 8, _hoisted_26))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["name", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", {
            class: "fd-invest-box-tabs-more",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleToMore()))
          }, "更多")
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createVNode(_component_el_container, { class: "fd-invest-divider2" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, { class: "fd-invest-strategy-banner" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_image, {
              src: require('@/assets/fd/invest/strategy_img.png')
            }, null, 8, ["src"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_el_container, { class: "fd-invest-divider2" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_divider, { "content-position": "center" }, {
              default: _withCtx(() => [
                _hoisted_38
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_container, { class: "fd-invest-box-line" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bindData).ownerActivitys, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "fd-invest-box-item",
                key: item.id,
                onClick: () => handleToDetail(item)
              }, [
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_el_image, {
                    class: "",
                    src: item.thumbnailUrl
                  }, null, 8, ["src"]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["fd-invest-box-item-img-status", _unref(bindData).calssType[item.status]])
                  }, null, 2),
                  _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(bindData).type[item.status]), 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_el_container, { class: "fd-invest-box-item-info-tp" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, _toDisplayString(item.name), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, {
                    gutter: 20,
                    class: "fd-index-box-item-info-ct list-row"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 14,
                        class: "col-left"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.pushTime), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, {
                        span: 10,
                        class: "col-right",
                        style: {"color":"red"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_45
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_row, {
                    gutter: 20,
                    class: "fd-index-box-item-info-bt list-row"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, {
                        span: 14,
                        class: "col-left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_46, [
                            _createVNode(_component_el_image, {
                              class: "bbs-list-item-logo-icon",
                              mode: "widthfix",
                              src: item.companyLogo,
                              style: {"width":"35px","height":"35px","margin-right":"3px"}
                            }, null, 8, ["src"]),
                            _createElementVNode("span", _hoisted_47, _toDisplayString(item.companyName), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ], 8, _hoisted_39))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(Bottom)
  ]))
}
}

})